/**
 * Server API aggregator
 */
import VideoTrimming from './service/videoTrimming';
import Asset from './service/asset';
import AssetGallery from './service/assetGallery';
import GetTimeLineModel from './service/getTimeLineModel';
import UseCaseList from './service/useCaseList';
import TextTime from './service/textTime';
import ProducedStoryPreviews from './service/producedStoryPreviews';
import TranslateService from './service/translate';
import RenderAsset from './service/renderAsset';
import Scraper from './service/scraper';
import HandleTask from './service/handleTask';
import DraftStories from './service/draftStories';
import DraftStoryPreviews from './service/draftStoryPreviews';
import DraftStoriesAutosave from './service/draftStoriesAutosave';
import ProducedStories from './service/producedStories';
import DraftStoryTemplates from './service/draftStoryTemplates';
import ProducedStoryTemplates from './service/producedStoryTemplates';
import SocialProvider from './service/socialProvider';
import GetAssetStoryBoard from './service/getAssetStoryBoard';
import InstagramEntities from './service/instagramEntities';
import FullPreview from './service/fullPreview';
import Handshake from './service/handshake';
import SearchAutoCompleteSuggestions from './service/searchAutoCompleteSuggestions';
import SearchAutoCompleteMaps from './service/searchAutoCompleteMaps';
import Fonts from './service/fonts';
import ThemeInfo from './service/themeInfo';
import Narration from './service/narration';
import TextStyles from './service/textStyles';
import RealTime from './service/realTime';
import FeStash from './service/feStash';
import BackgroundMusic from './service/backgroundMusic';
import GetSocialVideoTargetsList from './service/getSocialVideoTargetsList';
import Invitations from './service/invitations';
import Dashboards from './service/dashboards';
import SceneDetection from './service/sceneDetection';
import AllowedProgrammers from './service/allowedProgrammers';
import Videos from './service/videos';
import ReadyMadeVideos from './service/readyMadeVideos';
import Storyboards from './service/storyboards';
import InstagramExt from './service/instagramExt';
import SearchRecommendations from './service/searchRecommendations';
import Wallpapers from './service/wallpapers';
import StoryboardSchemas from './service/storyboardSchemas';
import Settings from './service/settings';
import RenderApi from './service/renderApi';
import Programmers from './service/programmers';
import Transcriptions from './service/transcriptions';
import Waveform from './service/waveform';
import Beats from './service/beats';
import TextToSpeech from './service/textToSpeech';
import PromptTemplates from './service/promptTemplates';
import ObjectTracking from './service/objectTracking';

const api = {
  videoTrimming: new VideoTrimming(),
  asset: new Asset(),
  assetGallery: new AssetGallery(),
  getTimeLineModel: new GetTimeLineModel(),
  useCaseList: new UseCaseList(),
  textTime: new TextTime(),
  producedStoryPreviews: new ProducedStoryPreviews(),
  translateService: new TranslateService(),
  renderAsset: new RenderAsset(),
  scraper: new Scraper(),
  handleTask: new HandleTask(),
  draftStories: new DraftStories(),
  draftStoryPreviews: new DraftStoryPreviews(),
  producedStories: new ProducedStories(),
  draftStoryTemplates: new DraftStoryTemplates(),
  producedStoryTemplates: new ProducedStoryTemplates(),
  draftStoriesAutosave: new DraftStoriesAutosave(),
  socialProvider: new SocialProvider(),
  getAssetStoryBoard: new GetAssetStoryBoard(),
  instagramEntities: new InstagramEntities(),
  fullPreview: new FullPreview(),
  handshake: new Handshake(),
  searchAutoCompleteSuggestions: new SearchAutoCompleteSuggestions(),
  searchAutoCompleteMaps: new SearchAutoCompleteMaps(),
  fonts: new Fonts(),
  themeInfo: new ThemeInfo(),
  narration: new Narration(),
  textStyles: new TextStyles(),
  realTime: new RealTime(),
  feStash: new FeStash(),
  backgroundMusic: new BackgroundMusic(),
  getSocialVideoTargetsList: new GetSocialVideoTargetsList(),
  invitations: new Invitations(),
  dashboards: new Dashboards(),
  sceneDetection: new SceneDetection(),
  allowedProgrammers: new AllowedProgrammers(),
  videos: new Videos(),
  readyMadeVideos: new ReadyMadeVideos(),
  storyboards: new Storyboards(),
  instagramExt: new InstagramExt(),
  searchRecommendations: new SearchRecommendations(),
  wallpapers: new Wallpapers(),
  StoryboardSchemas: new StoryboardSchemas(),
  Settings: new Settings(),
  renderApi: new RenderApi(),
  programmers: new Programmers(),
  Transcriptions: new Transcriptions(),
  waveform: new Waveform(),
  beats: new Beats(),
  textToSpeech: new TextToSpeech(),
  promptTemplates: new PromptTemplates(),
  objectTracking: new ObjectTracking(),
};

export default api;
